const ar = [
    {
        value: 'ARS',
        text: 'ARS',
    },
    {
        value: 'USD',
        text: 'USD'
    }
]

const es = [
    {
        value: 'EUR',
        text: 'EUR',
    },
    {
        value: 'USD',
        text: 'USD'
    }
]

const uy = [
    {
        value: 'UYU',
        text: 'UYU',
    },
    {
        value: 'USD',
        text: 'USD'
    }
]

const cl = [
    {
        value: 'CLP',
        text: 'CLP',
    },
    {
        value: 'UF',
        text: 'UF',
    },
    {
        value: 'USD',
        text: 'USD'
    }
]

const mx = [
    {
        value: 'MNX',
        text: 'MNX',
    },
    {
        value: 'USD',
        text: 'USD'
    }
]

const co = [
    {
        value: 'COP',
        text: 'COP',
    },
    {
        value: 'USD',
        text: 'USD'
    }
]

export default {
    ar,
    es,
    uy,
    cl,
    mx,
    co
}
